import { Activity, HttpActivity, HttpSessionActivity, ActivitySession } from '../models/activity.model';
import { timestampToDate } from './date.helper';

export function httpActivityToActivity(httpActivity: HttpActivity): Activity {
  return {
    ...httpActivity,
    last_start_date: timestampToDate(httpActivity.last_start_date),
  };
}


export function httpActivitySessionToSession(httpSession: HttpSessionActivity): ActivitySession {
  return {
    ...httpSession,
    created_at: timestampToDate(httpSession.created_at),
  };
}
